import isNumber from "lodash/isNumber"

export const forEach = (arr, fn) => {
  if (!arr.length || !fn) {
    return;
  }
  let i = -1,
    len = arr.length;
  while (++i < len) {
    let item = arr[i];
    fn(item, i, arr);
  }
};
/*
 @params targetarr 目标数组
 @arr 需要查询的数组
 @desc 判断要查询的数组是否至少有一个元素包含在目标数组中
  * */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1);
};

export const extendObj = (target, source) => {
  if (typeof target !== "object") {
    target = {};
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = extendObj(sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
};

export const typeOf = function (obj) {
  const toString = Object.prototype.toString;
  const map = {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object"
  };
  return map[toString.call(obj)];
};

export const deepCopy = data => {
  const t = typeOf(data);
  let o;
  if (t === "array") {
    o = [];
  } else if (t === "object") {
    o = {};
  } else {
    return data;
  }

  if (t === "array") {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === "object") {
    for (let i in data) {
      o[i] = deepCopy(data[i]);
    }
  }
  return o;
};

export const extend = (to, _from) => {
  for (let key in _from) {
    to[key] = _from[key];
  }
  return to;
};

// 判断参数是否是其中之一
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

// 去掉数组中的空元素
export function skipEmptyElementForArray(arr) {
  const result = [];
  arr.forEach(item => {
    let data = item.trim();
    if ("" !== data) {
      result.push(data);
    }
  });
  return result;
}

import jsonSchema from "json-schema";

export function propsSchema(install, Schema) {
  let valid = jsonSchema.validate(install, Schema);
  if (valid.valid) {
    return true;
  } else {
    console.error(valid.errors);
    return false;
  }
}

//判断是对象或者数据
export const isObject = obj => {
  return typeOf(obj) === "object" || typeOf(obj) === "array";
}

export const isEqual = (obj1, obj2) => {
  //如果不是个对象，直接比较就好了
  if (!isObject(obj1) || !isObject(obj2)) {
    return obj1 === obj2;
  }
  if (obj1 === obj2) {
    return true;
  }
  //都是引用类型，而且不相等
  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);
  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }
  for (let key in obj1) {
    const res = isEqual(obj1[key], obj2[key]);
    if (!res) {
      return false;
    }
  }
  return true;
};

// //判断两个数组的值是否相等
// export function isArrayValueEqual(a, b) {
//   if (a.length !== b.length) {
//     return false;
//   }
//
//   for (let i = 0; i < a.length; i++) {
//     let aItem = a[i];
//     return b.includes(aItem);
//   }
// }
//
// // 判断两个对象是否相等
// export function isObjectValueEqual(a, b) {
//   let aProps = Object.getOwnPropertyNames(a);
//   let bProps = Object.getOwnPropertyNames(b);
//   if (aProps.length !== bProps.length) {
//     return false;
//   }
//   for (let i = 0; i < aProps.length; i++) {
//     let propName = aProps[i];
//     let propA = a[propName];
//     let propB = b[propName];
//     if (typeOf(propA) === "object") {
//       if (isObjectValueEqual(propA, propB)) {
//         return true;
//       } else {
//         return false;
//       }
//     } else if (typeOf(propA) === "array") {
//       //判断两个数组是否相等
//       return isArrayValueEqual(propA, propB);
//     } else if (propA !== propB) {
//       return false;
//     }
//   }
//   return true;
// }
// 精确乘
export function accMul(a, b) {
  let m = 0
  let s1 = String(a)
  let s2 = String(b)
  try {
    m += s1.split(".")[1].length
  } catch {
    //
  }
  try {
    m += s2.split(".")[1].length
  } catch {
    //
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}
// 转化为百分数
export function toPercent(number) {
  number = Number(number)
  if (!isNumber(number)) return "--"
  const res = accMul(number, 100)
  if (isNaN(res)) return "--"
  return res.toFixed(1).replace(".0", "") + "%"
}

// 将某个属性值除以100
export function percentField(obj, key) {
  if (!Array.isArray(obj)) {
    obj = [obj]
  }
  if (!Array.isArray(key)) {
    key = [key]
  }
  obj.forEach(o => {
    key.forEach(k => {
      if (isNaN(Number(o[k]))) return
      o[k] = Number(o[k]) / 100
    })
  })
}
